/* eslint-disable tailwindcss/no-arbitrary-value, tailwindcss/no-unnecessary-arbitrary-value -- CMS-1625 uses compact countdown digit geometry that has no named design token. */

import type { CountdownUnit } from './types';

const digitPositions = ['tens', 'ones'] as const;
const digitClassName =
  'font-mono relative flex h-5 w-[14px] items-center justify-center rounded-[2px] border border-campaign/yellow-complimentary bg-gradient-to-br from-buttons/cta to-buttons/cta-hover font-bold shadow-[0_1px_3px_rgba(0,0,0,0.1),0_1px_2px_rgba(0,0,0,0.1)] text-buttons/base text-[11px] leading-[11px] before:absolute before:inset-x-0 before:top-1/2 before:h-px before:bg-black/10';

type Props = {
  className: string;
  units: CountdownUnit[];
  value: string;
};

export function CountdownDigits({ className, units, value }: Props) {
  const groups = value.split(':');

  return (
    <span aria-label={value} className="flex h-5 shrink-0 items-center gap-[3px]">
      {units.map((unit, groupIndex) => (
        <span className="flex items-center gap-px" key={unit}>
          {digitPositions.map((position, digitIndex) => (
            <span className={digitClassName} key={`${unit}-${position}`}>
              {(groups[groupIndex] ?? '00')[digitIndex]}
            </span>
          ))}
          {groupIndex < units.length - 1 ? (
            <span
              className={`flex h-[15px] w-[6px] items-center justify-center font-bold text-[10px] leading-[15px] ${className}`}
            >
              :
            </span>
          ) : null}
        </span>
      ))}
    </span>
  );
}
